// extracted by mini-css-extract-plugin
export default {"main":"Header_main__CQ6Q2","mobileWrapper":"Header_mobileWrapper__nZZ64"};